<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->


<app-menu *ngIf="!isLoginRoute()"></app-menu>
<div *ngIf="!isLoginRoute()" class="body-w" [ngStyle]="{'margin-left': _ss.isOpen ? '250px' : '50px' }">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <notifier-container></notifier-container>
</div>
<div *ngIf="isLoginRoute()">
  <router-outlet></router-outlet>
  <notifier-container></notifier-container>
</div>
